import { styled, theme } from 'ui/theme';

export const Figure = {
  Component: styled('figure')`
    margin: 0;
    width: 100%;
  `,

  Wrapper: styled('div')`
    overflow: hidden;

    &[data-shape='circle'] {
      border-radius: ${theme.radii.pill};
    }

    &[data-shape='square'] {
      border-radius: ${theme.radii.small};
    }

    img {
      display: block;
      width: 100%;
    }
  `,

  Caption: styled('figcaption')`
    width: 100%;
    text-align: center;

    &[data-align='left'] {
      text-align: left;
    }

    &[data-align='right'] {
      text-align: right;
    }
  `,
};
